var _jsxFileName = "/codebuild/output/src3324576443/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/register/VerifyNumber/index.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IconClose, InformationalScreen, Stack } from '@adc/parallax-component-library';
import { LoadingModal } from '@adc/parallax-component-library';
import { ApiStatus, ErrorCode } from 'Constants';
import { useFormik } from 'formik';
import { useApiError } from 'Hooks';
import { Footer, MainContainer, RichText } from 'Components/utility';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
import { sendVerificationCode, updateVerification, verifyCode } from 'Services/patient';
import VerifyNumberComponents from './components';
import FullModalEdit from './components/FullModalEdit';
import validationSchema from './schema';
const mapStateToProps = ({
  auth: {
    account_id
  },
  env: {
    osType,
    osVersion,
    app,
    appVersion
  }
}) => {
  return {
    account_id,
    osType,
    osVersion,
    app,
    appVersion
  };
};
const connector = connect(mapStateToProps);
let numberPhone = '';
const VerifyNumber = ({
  data: {
    mobileNumber,
    onSuccessfulVerify,
    onCloseModal,
    taskID,
    showCloseButton
  },
  osType,
  osVersion,
  app,
  appVersion,
  account_id
}) => {
  const {
    showApiErrorModal,
    showNetworkErrorModal
  } = useApiError();
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const submitFunction = async data => {
    try {
      setIsLoading(true);
      await verifyCode({
        patientId: account_id,
        taskID,
        verificationCode: data.otp,
        app,
        appVersion,
        osType,
        osVersion
      });
      notifyApp('adc-webview:verify-mobile-attempt', {
        successful: true
      });
      onSuccessfulVerify === null || onSuccessfulVerify === void 0 || onSuccessfulVerify(numberPhone);
    } catch (err) {
      var _error$response;
      const error = err;
      notifyApp('adc-webview:verify-mobile-attempt', {
        successful: false,
        error: ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.code) || error.code || 'UNKNOWN_ERROR'
      });
      handleApiRequestError(error);
    } finally {
      setIsLoading(false);
    }
  };
  const formController = useFormik({
    initialValues: {
      otp: '',
      mobileNumber
    },
    validationSchema: validationSchema(),
    validateOnBlur: true,
    onSubmit: submitFunction
  });
  const {
    handleSubmit,
    setFieldError,
    setFieldTouched,
    setFieldValue,
    values,
    errors,
    touched
  } = formController;
  const showLockoutModal = () => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        header: i18n.t('VerifyMobileNumber.modals.tooManyCodesSentDialog.title'),
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 108,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.blockHCPUser.body",
          text: i18n.t('VerifyMobileNumber.modals.tooManyCodesSentDialog.body'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 109,
            columnNumber: 13
          }
        }))
      }
    });
  };
  const handleApiRequestError = useCallback(error => {
    var _error$response2;
    const code = (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.data.code;
    switch (error.status) {
      case ApiStatus.BAD_REQUEST:
        {
          if (code === ApiStatus.VERIFICATION_CODE_INCORRECT_CODE) {
            setFieldError('otp', i18n.t('VerifyMobileNumber.microcopy.errors.invalidCode'));
            return;
          }
          if (code === ApiStatus.INVALID_DATA_CODE) {
            setFieldError('mobileNumber', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'));
            return;
          }
          if (code === ApiStatus.VERIFICATION_CODE_EXPIRED_CODE) {
            setFieldError('otp', i18n.t('VerifyMobileNumber.microcopy.errors.invalidCode'));
            return;
          }
          break;
        }
      case ApiStatus.TOO_MANY_REQUESTS:
        {
          if (code === ApiStatus.LOCKOUT) {
            showLockoutModal();
            return;
          }
          break;
        }
      case ApiStatus.CONFLICT:
        if (code === ApiStatus.PHONE_NUMBER_ALREADY_EXISTS_CODE) {
          setFieldError('mobileNumber', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.enterDifferentNumber'));
        }
        break;
      default:
        error.code === ErrorCode.NETWORK_ERROR ? showNetworkErrorModal() : showApiErrorModal();
    }
  }, [setFieldError, showApiErrorModal, showNetworkErrorModal]);
  const handleCloseModal = () => {
    setOpenModal(false);
    setFieldValue('mobileNumber', numberPhone);
  };
  const handleFooterBtnModal = async () => {
    const isUpdateSuccessful = await handlePatchVerify(values.mobileNumber);
    if (isUpdateSuccessful) {
      await handleSendCode(values.mobileNumber);
      numberPhone = values.mobileNumber;
      setFieldValue('otp', '');
      setFieldError('otp', undefined);
      setFieldTouched('otp', false);
      setOpenModal(false);
    }
  };
  const handleResend = () => {
    handleSendCode(values.mobileNumber);
  };
  const handlePatchVerify = async phoneNumber => {
    try {
      await updateVerification({
        patientId: account_id,
        taskID,
        phoneNumber,
        app,
        appVersion,
        osType,
        osVersion
      });
      return true;
    } catch (err) {
      handleApiRequestError(err);
      return false;
    }
  };
  const handleSendCode = useCallback(async phoneNumber => {
    setIsLoading(true);
    try {
      await sendVerificationCode({
        patientId: account_id,
        taskID,
        phoneNumber,
        app,
        appVersion,
        osType,
        osVersion
      });
      return true;
    } catch (err) {
      handleApiRequestError(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, [account_id, app, appVersion, handleApiRequestError, osType, osVersion, taskID]);
  const onClosePressed = () => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        header: i18n.t('CreateAccountAccountInfo.modals.removeMobileNumber.title'),
        details: i18n.t('CreateAccountAccountInfo.modals.removeMobileNumber.body'),
        buttonLayout: 'column',
        primaryAction: {
          label: i18n.t('Global.microcopy.common.removeCap'),
          onPress: () => {
            onCloseModal === null || onCloseModal === void 0 || onCloseModal();
            store.dispatch({
              type: CLOSE_MODAL
            });
          },
          destructive: true
        },
        secondaryAction: {
          label: i18n.t('CreateAccountAccountInfo.microcopy.btnText.verifyNumber'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        }
      }
    });
  };
  useEffect(() => {
    if (!mobileNumber || !taskID) {
      mediator.publish('router:navigate', '/login');
      return;
    }
    handleSendCode(mobileNumber);
    numberPhone = mobileNumber;
  }, [handleSendCode, mobileNumber, onSuccessfulVerify, taskID]);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 276,
      columnNumber: 5
    }
  }, isLoading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading content",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 277,
      columnNumber: 21
    }
  }), openModal ? /*#__PURE__*/React.createElement(FullModalEdit, {
    handleFooterBtnModal: handleFooterBtnModal,
    formikForm: formController,
    onClose: handleCloseModal,
    isFooterDisabled: !values.mobileNumber || values.mobileNumber === numberPhone || Boolean(errors.mobileNumber && touched.mobileNumber),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 280,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(InformationalScreen, {
    topNavigationProps: {
      title: i18n.t('VerifyMobileNumber.title'),
      animatedTitle: true,
      buttonStart: showCloseButton ? {
        element: /*#__PURE__*/React.createElement(IconClose, {
          testID: 'VerifyMobileNumber.close-Pressable',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 297,
            columnNumber: 28
          }
        }),
        onPress: onClosePressed
      } : undefined
    },
    testID: "VerifyNumber",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 291,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Page, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 304,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(InformationalScreen.Content, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 305,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginTop: -8,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 306,
      columnNumber: 15
    }
  }, /*#__PURE__*/React.createElement(VerifyNumberComponents.Content, {
    formikForm: formController,
    onClickEditBtn: () => setOpenModal(true),
    disableEditBtn: showCloseButton,
    onButtonPress: handleResend,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 307,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(InformationalScreen.Footer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 315,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Footer, {
    buttonLabel: i18n.t('Global.microcopy.common.verify'),
    onButtonPress: handleSubmit,
    buttonTestID: "VerifyNumberRegistration.footerButton",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 316,
      columnNumber: 15
    }
  })))));
};
export default connector(VerifyNumber);